import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import Config from '../../../../Config';
import {clearHistory, saveToHistory} from '../IMEIDeviceRepairSlice';
import {dwhCompleted, dwhIDFCompleted, dwhPrivateSuccessScreenDisplayed} from '../reports/dwhReports';
import {gtag4} from 'app/utilities/analytics/tracking';
import Title from 'app/Components/Block/IMEIDeviceRepairBlock/Shared/Title';
import {connect} from 'react-redux';
import SuccessIcon from './../images/success.svg';
import InfoIcon from './../images/small-alert.svg';
import Helper from 'app/utilities/helper';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import EpiContext from '@episerver/spa-core/Spa';
import {isMobile} from 'react-device-detect';

const CompletedComponent = (props) => {
  const {selectedAccountOrgName, causeList, selectedIMEI, alternatePhone, deliveryPrice, dwhData, securityCode} = props.deviceRepairData;
  const selectedHetPay = props.portalState.selectedHetPay;
  const customerName = props.loginData.userDetails.firstName + ' ' + props.loginData.userDetails.lastName;
  const subscriber = props.loginData.userDetails.contactNumber;
  const phone = props.deviceRepairData.selectedPhoneNumber;
  const param2 = props.deviceRepairData.selectCauseForm.causeList[0].selectedCauseType;
  const param3 = props.deviceRepairData.selectCauseForm.causeList[0].selectedCauseSubType;
  const formatTime = time => time.split(':').slice(0, 2).join(':');
  const formatDate = date => {
    const [year, month, day] = date.split('-');
    const dateObject = new Date(year, month - 1, day);
    return `${dateObject.getDate().toString().padStart(2, '0')}.${(dateObject.getMonth() + 1).toString().padStart(2, '0')}.${dateObject.getFullYear().toString().slice(-2)}`;
  };

  const {
    pickUpTimeSlot: {lfdat: pickupLfdat, waitFrom: pickupWaitFrom, waitTo: pickupWaitTo, key: pickupKey},
    street,
    homeNum,
    city
  } = props.deviceRepairData.pickUpAddressForm;

  const {
    deliveryTimeSlot: {lfdat: deliveryLfdat, waitFrom: deliveryWaitFrom, waitTo: deliveryWaitTo, key: deliveryKey},
    street: deliveryStreet,
    homeNum: deliveryHomeNum,
    city: deliveryCity
  } = props.deviceRepairData.deliveryAddressForm;

  const pickupDate = formatDate(pickupLfdat);
  const deliveryDate = formatDate(deliveryLfdat);
  const pickupDay = pickupKey.split(' ').slice(0, 2).join(' ');
  const deliveryDay = deliveryKey.split(' ').slice(0, 2).join(' ');
  const pickupWaitFromFormatted = formatTime(pickupWaitFrom);
  const pickupWaitToFormatted = formatTime(pickupWaitTo);
  const deliveryWaitFromFormatted = formatTime(deliveryWaitFrom);
  const deliveryWaitToFormatted = formatTime(deliveryWaitTo);

  useEffect(() => {
    props.saveToHistory('success');
    let businessDetails ={ _subscriber: props.deviceRepairData.selectedPhoneNumber, 'מס קריאת שירות': props.deviceRepairData.createNotificationTicketNumber , 'מספר IMEI': props.deviceRepairData.selectedIMEI};
    if (props.isPrivate) {
      dwhIDFCompleted({customerName, subscriber, param2, param3});
    } else if (props.contentData.isFromPrivateSelfcare.value) {
      dwhPrivateSuccessScreenDisplayed({selectedHetPay, subscriber, selectedIMEI, causeList, alternatePhone, securityCode, deliveryPrice, customerName, selectedAccountOrgName, businessDetails})
    }
    else {
      dwhCompleted({selectedHetPay, customerName, subscriber, phone, param2, param3,businessDetails});
    }
    gtag4({
      event: 'DeviceRepair_SuccessPage',
      action: 'SuccessPage',
    });

    return () => {
      props.clearHistory();
    };
  }, []);

  if (typeof window.scrollTo === 'function') {
    window.scrollTo(0, 0);
  }

  async function buttonFunction() {
    var content = await props.context.loadContentByPath( props.isPrivate ? Config.lobbyUrl : Config.businessLobbyUrl);
    props.context.navigateTo(content);
  }

  const titleText = [
    'שליחות לתיקון מכשיר ',
    isMobile ? <br /> : null,
    'נקבעה ',
    !isMobile ? <br /> : null,
    'בהצלחה!'];

  const subtext = [
    'מספר סידורי ',
    <b>IMEI {props?.deviceRepairData?.selectedIMEI}</b>
  ];

  const saveToCalendar = () => {
    const pickupEvent = {
      start: pickupLfdat.split('-').map(Number).concat(pickupWaitFrom.split(':').map(Number)),
      duration: {hours: Math.abs(pickupWaitTo.split(':')[0] - pickupWaitFrom.split(':')[0])},
      title: `ביקור טכנאי ${window.Config.brand_Name_HE} איסוף ${window.Config.brand_Name_HE}`,
      location: `${street} ${homeNum}, ${city}`,
      status: 'CONFIRMED',
      busyStatus: 'BUSY'
    };

    const deliveryEvent = {
      start: deliveryLfdat.split('-').map(Number).concat(deliveryWaitFrom.split(':').map(Number)),
      duration: {hours: Math.abs(deliveryWaitTo.split(':')[0] - deliveryWaitFrom.split(':')[0])},
      title: `ביקור טכנאי ${window.Config.brand_Name_HE} החזרת מכשיר`,
      location: `${deliveryStreet} ${deliveryHomeNum}, ${deliveryCity}`,
      status: 'CONFIRMED',
      busyStatus: 'BUSY'
    };

    Helper.saveToCalendarCustomize([pickupEvent, deliveryEvent]);
  };




  return (
    <div className="imei-success-container">
      <Image src={SuccessIcon} alt="success" className="success-icon" />
      <div className={'content'}>
        <Title text={titleText} subtext={subtext} />
        <div className="date-info">
          <span
            className={'date cellcom-color'}> קבענו איסוף למכשיר ב{pickupDay} {pickupDate}</span>
          <span className="hours">
            {`בין ${pickupWaitFromFormatted}-${pickupWaitToFormatted}`}<br />
            {`ב${street} ${homeNum}, ${city}`}
          </span>
        </div>
        <div className="date-info">
          <span
            className={'date cellcom-color'}> קבענו החזרה למכשיר ב{deliveryDay} {deliveryDate}</span>
          <span className="hours">
          {`בין ${deliveryWaitFromFormatted}-${deliveryWaitToFormatted}`}<br />
            {`ב${deliveryStreet} ${deliveryHomeNum}, ${deliveryCity}`}
          </span>
        </div>
      </div>
      <div className="notes">
        <span className="title">
        חשוב לנו להדגיש</span>
        <div className="note">
          <Image src={InfoIcon} alt="info" className="note-icon" />
          <span className="note-text">חשוב לגבות תכנים לפני איסוף המכשיר לתיקון</span>
        </div>
        <div className="note">
          <Image src={InfoIcon} alt="info" className="note-icon" />
          <span className="note-text">בזמן ביקור השליח, חייב להיות בבית מבוגר<br />
מעל גיל 18</span>
        </div>
      </div>
      <div className="bottom-container">
        <div className="save-and-schedule">
          <div onClick={() => Helper.saveToImage('.imei-device-repair-main-container')}>שמירה כתמונה</div>
          <div onClick={saveToCalendar}>הוספת תזכורת ליומן</div>
        </div>
        <BtnSubmit isBusiness text="לאזור האישי" onclick={() => buttonFunction()} />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {deviceRepairData: state.iMEIDeviceRepair, portalState: state.portalsBlock ,loginData: state.authentication.loginData};
};

const mapDispatchToProps = {
  clearHistory,
  saveToHistory
};

export default connect(mapStateToProps, mapDispatchToProps)(CompletedComponent);
